// 引入Http请求封装
import { Http } from "@ajx-common/trth-web-common";
import { getToken, getTenantId } from "@/utils/auth";
import { clearData } from "@/common/auth";
import router from "@/router";

export default new Http({
  baseUrl: process.env.VUE_APP_BASE_API,
  timeout: 30000,
  getToken,
  getTenantId,
  redirectToLoginPage() {
    clearData();
    router.replace({
      name: "Login",
    });
  },
});
